import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import HummAnimation from './component/dashboard/home/hummAnimation';
import Login from './component/auth/login/login';
import Home from './component/dashboard/home/home';
import PrivateRoute from './PrivateRoute.jsx';
import PublicRoute from './publicRoute.jsx';
import SimpleSlider from './component/dashboard/home/simpleSlider';
import { Provider } from 'react-redux';
import store from './store';
import ErrorBoundary from './component/errorBoundary/errorBoundary';
import ForgotPassword from './component/auth/login/forgotPassword';
import ForgotPasswordCode from './component/auth/login/forgotPasswordCode';
import Welcome from './component/dashboard/home/welcome';
import Layout from './component/layout/layout';

import Partner from './component/partner/partner';
import FavoritePartner from './component/partner/favoritePartner';
import ViewPartner from './component/partner/viewedPartner';
import MyAccount from './component/accountSetting/myAccount';

import Application from './component/application/application';
import QrCode from './component/miteck/qrCode';
import HummVerificationPage from './component/miteck/hummVerificationPage';

import Wallet from './component/wallet/wallet';
import WalletContract from './component/wallet/walletContract';
import Addcard from './component/card/addCard';

import SessionExpiered from './component/sessionExpiered/sessionExpiered';
import ScrollToTop from './utils/scrollToTop';

import ApplyRedirect from './component/application/applyRedirect';
import QuoteCalculator from './component/quoteCalculator/quoteCalculator';
import QuoteCalculatorResults from './component/quoteCalculator/quoteCalculatorResults';
import NotFound from './component/notFound/notFound';
import PhoneVerification from './component/auth/register/phoneVerification';
import { MobileTermsPage } from './component/termsAndConditions/mobileTerms';
import ApplicationLanding from './component/application/applicationLanding';
import openBankingConsent from './component/application/openBankingConsent.jsx';
import ObVerificationPage from './component/openBanking/obVerificationPage.jsx';
import AdminDashboard from './component/admin/adminDashboard.jsx';
import AdminVerification  from './component/auth/login/adminVerification.jsx';
import AdminRoute from './AdminRoute.jsx';
import AdminUserView from './component/admin/adminUserView.jsx';
export default function AppRoutes() {
	return (
		<Provider store={store}>
			<Router>
				<ScrollToTop />
				<Routes>
					<Route element={<PublicRoute />}>
						<Route path="/" element={<HummAnimation />} />
						<Route path="/application-landing" element={<ApplicationLanding />} />
						<Route path="/login" element={<Login />} />
						<Route path="/welcome" element={<Welcome />} />
						<Route path="/forgot-password" element={<ForgotPassword />} />
						<Route path="/forgot-password-code" element={<ForgotPasswordCode />} />
						<Route path="/humm-verfication/:doc" element={<HummVerificationPage />} />
						<Route path="/session-expired" element={<SessionExpiered />} />
						<Route path="/page-not-found" element={<NotFound />} />
						<Route path="/apply" element={<ApplyRedirect />} />
						<Route path="/mobile-terms" element={<MobileTermsPage />} />
						<Route path="/ob-verification/:doc/:flow" element={<ObVerificationPage/>}/>
                        <Route path='/admin-verification' element={<AdminVerification/>}/>
					</Route>

					<Route element={<Layout />}>
						<Route element={<PrivateRoute />}>
							<Route path="/home" element={<Home />} />
							<Route path="/shop" element={<Partner />} />
							<Route path="/favorite-partner" element={<FavoritePartner />} />
							<Route path="/wallet" element={<Wallet />} />
							<Route path="/wallet-contract-detail" element={<WalletContract />} />
							<Route path="/viewed-partner" element={<ViewPartner />} />
							<Route path="/my-account" element={<MyAccount />} />
							<Route path="/addcard" element={<Addcard />} />
							<Route path="/QrCode" element={<QrCode />} />
							<Route path="/application" element={<Application />} />
							<Route path="/apply" element={<ApplyRedirect />} />
							<Route path="/quote-calculator" element={<QuoteCalculator/>} />
							<Route path="/quote-calculator-results" element={<QuoteCalculatorResults />} />
							<Route path="/mobile-verification" element={<PhoneVerification />} />
						</Route>
					</Route>

                    <Route element={<AdminRoute/>}>
                        <Route path='/admin-dashboard' element={<AdminDashboard/>}/>
                        <Route path='/admin-user-view' element={<AdminUserView/>}/>
                    </Route>

					{/* Error Boundary */}
					<Route element={<ErrorBoundary />}>
						<Route path="/slider" element={<SimpleSlider />} />
					</Route>
				</Routes>
			</Router>
		</Provider>
	);
}